// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__uLEpa","title":"BackImages_title__20acD","images":"BackImages_images__3Zp1y"};